import React from "react";
import { Container, Row, Col } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import PrimaryButton from "../primaryButton";
import s from "./styles.scss";

export interface ErrorDisplayProps {
  errorMessage: string;
  title?: string;
  iconClass?: string;
  showRetry?: boolean;
  retryText?: string;
  onRetry?: () => void;
  showBack?: boolean;
  backText?: string;
  onBack?: () => void;
  supportMessage?: string;
  hideSupportSection?: boolean;
  className?: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  errorMessage,
  title = "Setup Error",
  iconClass = "fas fa-exclamation-triangle",
  showRetry = true,
  retryText = "Try Again",
  onRetry = () => window.location.reload(),
  showBack = false,
  backText = "Go Back",
  onBack,
  supportMessage = "If this error persists, please contact our support team for assistance. We're here to help you get your organization set up successfully.",
  hideSupportSection = false,
  className = "",
}) => {
  return (
    <Container fluid className={className}>
      <Row className="justify-content-center mt-5">
        <Col md={8} lg={6}>
          <div className="text-center p-4">
            <div className="mb-4">
              <i className={`${iconClass} text-danger`} style={{ fontSize: '4rem' }}></i>
            </div>
            <h3 className="mb-3 text-danger">{title}</h3>
            <p className="mb-4 fw-bolder" style={{ color: '#6c757d' }}>
              {errorMessage}
            </p>

            {(showRetry || showBack) && (
              <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mb-4">
                {showRetry && (
                  <PrimaryButton
                    onClick={onRetry}
                    className="px-4"
                  >
                    <i className="fas fa-redo me-2"></i>
                    {retryText}
                  </PrimaryButton>
                )}
                {showBack && onBack && (
                  <PrimaryButton
                    onClick={onBack}
                    className="px-4"
                    variant="secondary"
                  >
                    <i className="fas fa-arrow-left me-2"></i>
                    {backText}
                  </PrimaryButton>
                )}
              </div>
            )}

            {!hideSupportSection && (
              <div className="border-top pt-3">
                <p className="small text-muted mb-2">
                  <strong>Need help?</strong>
                </p>
                <p className="small fw-bolder" style={{ color: '#6c757d' }}>
                  {supportMessage}
                </p>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default withStyles(s)(ErrorDisplay);
